import { getFeaturedBooks } from '@/db/queries';
import { getBookCover, getPlaceholderImage, slugify } from '@/lib/utils';

<!-- Hero Section -->
<section class="relative overflow-hidden bg-black py-20 md:py-32">
  <div class="absolute inset-0 z-0 opacity-95">
    <div class="object-cover w-full h-full bg-cover bg-center bg-no-repeat bg-[url(data:image/png;base64,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)]" />
  </div>
  <div class="relative z-10 container mx-auto px-4">
    <div class="max-w-3xl">
      <span class="mb-4 inline-block bg-yellow-500 text-black hover:bg-yellow-600 px-3 py-1 rounded-full text-sm font-medium">
        New Releases
      </span>
      <h1 class="text-4xl md:text-6xl font-bold text-white mb-6 [text-shadow:_2px_2px_0_rgba(0_0_0_1.0)] capitalize">
        Laugh Out Loud in Every Panel
      </h1>
      <p class="text-lg md:text-xl text-white/90 mb-8">
        Step into a world where every panel is packed with side-splitting gags, quirky characters, and adventures that'll have you laughing out loud.
      </p>

      <try>
        <@placeholder>
          <div class="flex flex-wrap gap-4">
            <div class="h-12 w-40 bg-white/20 rounded-lg animate-pulse"></div>
            <div class="h-12 w-40 bg-white/20 rounded-lg animate-pulse"></div>
          </div>
        </@placeholder>

        <@catch|error|>
          <div class="flex flex-wrap gap-4">
            <a href="/books">
              <button class="bg-transparent hover:bg-white/10 text-white border border-white/20 px-6 py-3 rounded-lg font-medium">
                Browse Collection
              </button>
            </a>
          </div>
        </@catch>

        <await|featuredBooks|=getFeaturedBooks()>
          <div class="flex flex-wrap gap-4">
            <if=(featuredBooks.length > 0)>
              <const/firstBookSlug=slugify(featuredBooks[0].title)/>
              <const/firstBookUrl=`/books/${featuredBooks[0].id}/${firstBookSlug}`>
              <a href=firstBookUrl>
                <button class="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-medium inline-flex items-center gap-2">
                  Start Reading
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
                    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
                  </svg>
                </button>
              </a>
            </if>
            <a href="/books">
              <button class="text-white border-transparent bg-white/9 hover:bg-white/10 px-6 py-3 rounded-lg font-medium">
                Browse Collection
              </button>
            </a>
          </div>
        </await>
      </try>
    </div>
  </div>
</section>

<!-- Featured Comics Section -->
<section class="py-16 container mx-auto px-4">
  <div class="flex justify-between items-center mb-10">
    <h2 class="text-3xl font-bold">Featured Comics</h2>
    <a href="/books">
      <button class="bg-transparent hover:bg-gray-100 px-4 py-2 rounded-md text-sm font-medium">
        View All
      </button>
    </a>
  </div>

  <try>
    <@placeholder>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-6">
        <for|i| of=[1, 2, 3, 4]>
          <div class="rounded-lg border bg-card shadow-sm overflow-hidden">
            <div class="relative aspect-[2/3] bg-muted animate-pulse"></div>
            <div class="p-4">
              <div class="h-6 bg-muted rounded mb-2 animate-pulse"></div>
              <div class="h-4 bg-muted rounded w-2/3 mb-3 animate-pulse"></div>
              <div class="h-10 bg-muted rounded animate-pulse"></div>
            </div>
          </div>
        </for>
      </div>
    </@placeholder>

    <@catch|error|>
      <div class="text-center py-12">
        <p class="text-muted-foreground">
          ${error instanceof Error ? error.message : 'Failed to load featured comics'}
        </p>
      </div>
    </@catch>

    <await|featuredBooks|=getFeaturedBooks()>
      <if=featuredBooks.length === 0>
        <div class="text-center py-12">
          <p class="text-muted-foreground">No featured comics available.</p>
        </div>
      </if>
      <else>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-6">
          <for|book| of=featuredBooks>
            <const/coverPath=getBookCover(book)>
            <const/placeholderPath=getPlaceholderImage()>
            <const/bookSlug=slugify(book.title)/>
            <const/bookUrl=`/books/${book.id}/${bookSlug}`>
            <const/bookAuthor=book.author || ''>
            <const/onErrorScript=`this.src='${placeholderPath}'`>

            <div class="group rounded-lg border bg-card shadow-sm hover:shadow-xl transition-shadow overflow-hidden">
              <a href=bookUrl class="block">
                <div class="relative aspect-[2/3] overflow-hidden">
                  <img
                    src=coverPath
                    alt=book.title
                    onerror=onErrorScript
                    class="object-cover w-full h-full group-hover:scale-105 transition-transform"
                  />
                </div>
                <div class="p-4">
                  <h3 class="font-bold mb-2 text-gray-900 group-hover:text-primary transition-colors">
                    ${book.title}
                  </h3>
                  <p class="text-sm text-gray-500 mb-3">${bookAuthor}</p>
                  <button class="w-full bg-gray-100 hover:bg-gray-200 text-gray-900 px-4 py-2 rounded-md font-medium inline-flex items-center justify-center gap-2">
                    Read Now
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
                    </svg>
                  </button>
                </div>
              </a>
            </div>
          </for>
        </div>
      </else>
    </await>
  </try>
</section>
